const orderStatusTitleMap = {
  charge: '儲值',
  paid: '使用',
  refund: '退款',
  withdraw: '結清轉現',
};

const orderColorMap = {
  charge: '',
  paid: '',
  refund: '',
  withdraw: '',
};

export default function formatDeposit(orderItem = {}) {
  return {
    title: formatDepositStatusTitle(orderItem.status),
    color: formatDepositColor(orderItem.status),
  }
}

export function formatDepositStatusTitle(status) {
  return orderStatusTitleMap[status]
}

export function formatDepositColor(status) {
  return orderColorMap[status]
}
